import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import Navbar from "../components/navbar";
import curvedBanner from "../assect/images/bg/dl_curvedimgs_contact.png";

import Footer from "../components/footer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import AvailableProperties from "../components/availableproperties";
import ReactGA from 'react-ga4';
export default function ContactUs() {
    const apiPath = `${process.env.REACT_APP_API_URL}api/Properties`;
    const [loading, setLoading] = useState(true);
    const [moveInDate, setMoveInDate] = useState(null);
    const [moveOutDate, setMoveOutDate] = useState(null);
    const [property, setProperty] = useState({});
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        comments: ''
    });
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState('');
    const { propertyId } = useParams();
    const handleInputChange = (e) => {
        setSubmitMessage("")
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        // Required field validation
        if (!formData.name.trim()) {
            newErrors.name = 'Name is required';
        }

        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = 'Email is invalid';
        }

        if (!formData.phone.trim()) {
            newErrors.phone = 'Phone is required';
        }

        if (!moveInDate) {
            newErrors.moveInDate = 'Move-in date is required';
        }

        if (!moveOutDate) {
            newErrors.moveOutDate = 'Move-out date is required';
        }

        if (!formData.subject.trim()) {
            newErrors.subject = 'Subject is required';
        }

        if (!formData.comments.trim()) {
            newErrors.comments = 'Message is required';
        }

        // Date validation
        if (moveInDate && moveOutDate && moveInDate >= moveOutDate) {
            newErrors.moveOutDate = 'Move-out date must be after move-in date';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const formatDateForAPI = (date) => {
        if (!date) return '';

        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
        const day = date.getDate().toString().padStart(2, '0');

        return `${year}-${month}-${day}`; // e.g., 2025-08-12
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setIsSubmitting(true);
        setSubmitMessage('');

        // Track form submission event
        ReactGA.event({
            category: 'User',
            action: 'Form Submit',
            label: 'Contact Form'
        });

        try {
            const payload = {
                name: formData.name,
                email: formData.email,
                phone: formData.phone,
                beginningDate: formatDateForAPI(moveInDate),
                endingDate: formatDateForAPI(moveOutDate),
                subject: formData.subject,
                message: formData.comments,
                ...(propertyId ? { id: Number(propertyId) } : {})
            };

            const response = await axios.post(`${process.env.REACT_APP_API_URL}Smtp`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                },
                timeout: 10000, // 10 second timeout
            });

            if (response.status === 200 || response.status === 201) {
                setSubmitMessage('Message sent successfully! We will respond to your inquiry within a few hours.');
                // Reset form
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    subject: '',
                    comments: ''
                });
                setMoveInDate(null);
                setMoveOutDate(null);
                setErrors({});
            }
        } catch (error) {
            console.error('Error sending message:', error);

            if (error.response) {
                // Server responded with error status
                setSubmitMessage(`Error: ${error.response.status} - ${error.response.data?.message || 'Failed to send message'}`);
            } else if (error.request) {
                // Request was made but no response received
                setSubmitMessage('Network error: Unable to reach the server. Please try again.');
            } else {
                // Something else happened
                setSubmitMessage('Failed to send message. Please try again.');
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    const getInputStyle = (fieldName) => ({
        borderColor: errors[fieldName] ? "#dc3545" : "#lt-grey",
        borderWidth: errors[fieldName] ? "2px" : ".5px",
        borderStyle: "solid"
    });
    const fetchData = async (apiGetPath) => {
        setLoading(true);
        try {
            // grab data from api and place into state
            const response = await axios.get(apiGetPath);
            const data = response.data;

            setProperty(prevState => ({
                ...prevState, ...data
            }));
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }

    useEffect(() => {
        if (propertyId) {
            let apiGetPath = `${apiPath}/${propertyId}`;
            fetchData(apiGetPath);
        }
    }, [propertyId])

    return (
        <div style={{ backgroundColor: "#f0eadd" }}>
            <Navbar navClass="defaultscroll sticky" menuClass="navigation-menu nav-right" />
            <div className="top-half top-half d-table w-100 pt-5">
                <section className="bg-half-116" style={{ backgroundImage: `url(${curvedBanner})` }}>
                </section>
            </div>

            <section className="section-50 pb-0">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xxl-6 col-xl-8 col-md-10 col-12">
                            <p className="mb-md-5 mb-sm-3 sub_heading">Contact Us</p>

                            <div className="p-sm-5 p-3 rounded-3"
                                style={{ backgroundColor: "#FFF", borderColor: "#b65741", borderStyle: "solid" }}>
                                <form onSubmit={handleSubmit} style={{ backgroundColor: "#FFF" }}>
                                    {propertyId && (
                                        <div className=" mb-3">
                                            <span className="fw-bold text-secondary me-1">Contact for:</span>
                                            <span style={{ fontSize: "14px", fontWeight: 600 }}>
                                                {property?.address && (<span>{property.address}</span>)}
                                                {property?.unit && (
                                                    <>
                                                        , <span>{property.unit}</span>
                                                    </>
                                                )}
                                            </span>
                                        </div>



                                    )}
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="mb-3">
                                                <input
                                                    name="name"
                                                    id="name"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Name *"
                                                    value={formData.name}
                                                    onChange={handleInputChange}
                                                    style={getInputStyle('name')}
                                                />
                                                {errors.name && <small className="text-danger">{errors.name}</small>}
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <input
                                                    name="email"
                                                    id="email"
                                                    type="email"
                                                    className="form-control"
                                                    placeholder="Email *"
                                                    value={formData.email}
                                                    onChange={handleInputChange}
                                                    style={getInputStyle('email')}
                                                />
                                                {errors.email && <small className="text-danger">{errors.email}</small>}
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <input
                                                    name="phone"
                                                    id="phone"
                                                    type="tel"
                                                    className="form-control"
                                                    placeholder="Phone *"
                                                    value={formData.phone}
                                                    onChange={handleInputChange}
                                                    style={getInputStyle('phone')}
                                                />
                                                {errors.phone && <small className="text-danger">{errors.phone}</small>}
                                            </div>
                                        </div>

                                        <div className="col-sm-6 col-12">
                                            <div className="mb-3">
                                                <DatePicker
                                                    selected={moveInDate}
                                                    onChange={(date) => {
                                                        setMoveInDate(date);
                                                        if (errors.moveInDate) {
                                                            setErrors(prev => ({ ...prev, moveInDate: '' }));
                                                        }
                                                    }}
                                                    className="form-control"
                                                    placeholderText="Move-in Date *"
                                                    dateFormat="MM/dd/yyyy"
                                                    style={getInputStyle('moveInDate')}
                                                />
                                                {errors.moveInDate && <small className="text-danger">{errors.moveInDate}</small>}
                                            </div>
                                        </div>

                                        <div className="col-sm-6 col-12">
                                            <div className="mb-3">
                                                <DatePicker
                                                    selected={moveOutDate}
                                                    onChange={(date) => {
                                                        setMoveOutDate(date);
                                                        if (errors.moveOutDate) {
                                                            setErrors(prev => ({ ...prev, moveOutDate: '' }));
                                                        }
                                                    }}
                                                    className="form-control"
                                                    placeholderText="Move-out Date *"
                                                    dateFormat="MM/dd/yyyy"
                                                    style={getInputStyle('moveOutDate')}
                                                />
                                                {errors.moveOutDate && <small className="text-danger">{errors.moveOutDate}</small>}
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="mb-3">
                                                <input
                                                    name="subject"
                                                    id="subject"
                                                    className="form-control"
                                                    placeholder="Subject *"
                                                    value={formData.subject}
                                                    onChange={handleInputChange}
                                                    style={getInputStyle('subject')}
                                                />
                                                {errors.subject && <small className="text-danger">{errors.subject}</small>}
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="mb-3">
                                                <textarea
                                                    name="comments"
                                                    id="comments"
                                                    rows="4"
                                                    className="form-control"
                                                    placeholder="Message *"
                                                    value={formData.comments}
                                                    onChange={handleInputChange}
                                                    style={getInputStyle('comments')}
                                                ></textarea>
                                                {errors.comments && <small className="text-danger">{errors.comments}</small>}
                                            </div>
                                        </div>

                                    </div>
                                    <div className="row justify-content-center">
                                        <div className="col-xl-4 col-lg-5 col-sm-6 col-10">
                                            <div className="d-grid">
                                                <button
                                                    type="submit"
                                                    id="submit"
                                                    name="send"
                                                    className="btn btn-primary orange-button"
                                                    disabled={isSubmitting}
                                                >
                                                    {isSubmitting ? 'Sending...' : 'Send Message'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="d-grid">
                                                {submitMessage && (
                                                    <p className="mt-3" style={{
                                                        textAlign: "center",
                                                        fontSize: "14px",
                                                        color: submitMessage.includes('successfully') ? '#28a745' : '#dc3545'
                                                    }}>
                                                        {submitMessage}
                                                    </p>
                                                )}
                                                {!submitMessage && (
                                                    <p className="mt-3" style={{ textAlign: "center", fontSize: "14px" }}>
                                                        We will respond to your inquiry within a few hours.
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="position-relative avaliable_sec">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <AvailableProperties />
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

